export enum CENTERS {
  CONSULT = '5532',
}
